export { GHSLogo } from "./GHSLogo";
export { IxLogo } from "./IxLogo";
